import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const CONCEPT_DOMAIN = "concept";

export const CONCEPT_DETAIL_ENDPOINT = "detail";
export const CONCEPT_TMPLOAD_ENDPOINT = "tmp/load";
export const CONCEPT_TMPSAVE_ENDPOINT = "tmp/save";
export const CONCEPT_CONFIRM_ENDPOINT = "confirm";

export const CONCEPT_MEMOLOAD_ENDPOINT = "memo/load";
export const CONCEPT_MEMOSAVE_ENDPOINT = "memo/save";

export const CONCEPT_NOTE_DETAIL_ENDPOINT = "note/detail";
export const CONCEPT_NOTE_CONCERN_AND_GOAL_DETAIL_ENDPOINT =
  "note/concern-and-goal/detail";
export const CONCEPT_NOTE_BELIEFS_DETAIL_ENDPOINT = "note/beliefs/detail";
export const CONCEPT_NOTE_AUTOMATIC_THOUGHT_DETAIL_ENDPOINT =
  "note/automatic-thought/detail";
export const CONCEPT_NOTE_AUTOMATIC_THOUGHT_LIST_ENDPOINT =
  "note/automatic-thought/list";
export const CONCEPT_NOTE_UPDATE_ENDPOINT = "note/update";
export const CONCEPT_NOTE_AUTOMATIC_THOUGHT_ADD_ENDPOINT =
  "note/automatic-thought/add";
export const CONCEPT_NOTE_AUTOMATIC_THOUGHT_UPDATE_ENDPOINT =
  "note/automatic-thought/update";
export const CONCEPT_NOTE_AUTOMATIC_THOUGHT_DELETE_ENDPOINT =
  "note/automatic-thought/delete";
export const CONCEPT_NOTE_AUTOMATIC_THOUGHT_RESET_ENDPOINT =
  "note/automatic-thought/reset";
export const CONCEPT_NOTE_AUTOMATIC_THOUGHT_CONFIRM =
  "note/automatic-thought/confirm";
export const CONCEPT_NOTE_CONFIRM_ENDPOINT = "note/confirm";

export const CONCEPT_NOTE_REFERENCE_LIST_ENDPOINT = "note/reference/list";
export const CONCEPT_REFERENCE_DETAIL_ENDPOINT = "reference/detail";
export const CONCEPT_NOTE_REFERENCE_ADD_ENDPOINT = "note/reference/add";

export const CONCEPT_IMPACTSCORE_SUBMIT_ENDPOINT = "impact-score/submit";

export type ConceptFieldKeyType =
  | "concern"
  | "goal"
  | "coreExperience"
  | "coreBeliefsSelf"
  | "coreBeliefsOthers"
  | "coreBeliefsWorld"
  | "intermediateBeliefsRules"
  | "intermediateBeliefsAttitudes"
  | "intermediateBeliefsAssumptions";

export type AutomaticThoughtFieldKeyType =
  | "situation"
  | "thought1"
  | "thought1ThoughtTrap"
  | "thought2"
  | "thought2ThoughtTrap"
  | "emotion"
  | "physicalResponse"
  | "behavior"
  | "thoughtPositive"
  | "valueDomain"
  | "value";

export type AutomaticThoughtFieldMap = {
  [key in AutomaticThoughtFieldKeyType]?: string;
};

export type ConceptKeyType_concernAndGoal = "concern" | "goal" | "concernBrief";
export type ConceptKeyType_simple = "coreExperience";
export type CoreExperienceReferenceListType =
  `${ConceptKeyType_simple}ReferenceList`;

export type ConceptKeyType_coreBelief = "coreBelief";
export type CoreBeliefKeyType = "coreBelief1" | "coreBelief2" | "coreBelief3";
export type CoreBeliefReferenceListType = `${CoreBeliefKeyType}ReferenceList`;

export type ConceptKeyType_intermediateBelief = "intermediateBelief";
export type IntermediateBeliefKeyType = "rules" | "attitudes" | "assumptions";
export type IntermediateBeliefReferenceListType =
  `${IntermediateBeliefKeyType}ReferenceList`;

export type ConceptKeyType_copingStrategy = "copingStrategy";
export type CopingStrategyKeyType =
  | "surrender"
  | "overcompensation"
  | "avoidance";

export const intermediateBeliefKeyMapping: {
  [key in IntermediateBeliefKeyType]: string;
} = { rules: "규칙", attitudes: "태도", assumptions: "가정" };

export const coreBeliefKeyMapping: {
  [key in CoreBeliefKeyType]: string;
} = {
  coreBelief1: "스스로에 대해",
  coreBelief2: "다른 사람에 대해",
  coreBelief3: "이 세상에 대해",
};

export const conceptKeyMapping: {
  [key in IntermediateBeliefKeyType | CoreBeliefKeyType]: string;
} = { ...intermediateBeliefKeyMapping, ...coreBeliefKeyMapping };

// export type ConceptKeyType_automaticThought =
//   | "automaticThought1"
//   | "automaticThought2"
//   | "automaticThought3";

type NumberToString<N extends number> = `${N}`;
export type automaticThoughtIdType = NumberToString<
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 55
  | 56
  | 57
  | 58
  | 59
  | 60
  | 61
  | 62
  | 63
  | 64
  | 65
  | 66
  | 67
  | 68
  | 69
  | 70
  | 71
  | 72
  | 73
  | 74
  | 75
  | 76
  | 77
  | 78
  | 79
  | 80
  | 81
  | 82
  | 83
  | 84
  | 85
  | 86
  | 87
  | 88
  | 89
  | 90
  | 91
  | 92
  | 93
  | 94
  | 95
  | 96
  | 97
  | 98
  | 99
  | 100
>;

export const automaticThoughtIdList = Array.from(
  { length: 100 },
  (v, i) => `${i + 1}` as automaticThoughtIdType
);

export type ConceptKeyType_automaticThought =
  `automaticThought${automaticThoughtIdType}`;

export type ConceptKeyType_automaticThoughtForValue =
  `automaticThoughtForValue${automaticThoughtIdType}`;

type AutomaticThoughtCommonKeyType =
  | "situation"
  | "thought"
  | "emotion"
  | "physicalResponse"
  | "behavior";
export type AutomaticThoughtKeyType =
  | AutomaticThoughtCommonKeyType
  | "copingStrategy";

export type AutomaticThoughtForValueKeyType =
  | AutomaticThoughtCommonKeyType
  | "valueDomain"
  | "value";

export type ConceptKeyType_nested =
  | ConceptKeyType_coreBelief
  | ConceptKeyType_intermediateBelief
  | ConceptKeyType_copingStrategy
  | ConceptKeyType_automaticThought
  | ConceptKeyType_automaticThoughtForValue;

type EachStatus<N extends string> = `${N}Status`;
type ConceptItemStatusKey = EachStatus<ConceptKeyType_nested>;
export type ConceptItemStatus = "preparing" | "note_confirmed" | "confirmed";
export type AutomaticThoughtTaskProgressStatus = "in_progress" | "completed";

export type IndividualThoughtKeyType = `thought` | "thoughtTrap";
export type IndividualThoughtType = {
  [key in IndividualThoughtKeyType]: string;
};
export type IndividualThoughtNoteType = {
  [key in IndividualThoughtKeyType]: NoteType;
};

export interface ImpactScoreHistoryListType {
  score?: number;
  submittedAt: string;
  taskKey: string;
  automaticThoughtSequence: number;
  thought: string;
  thoughtTrap: string;
}

export type CoreBeliefType = {
  [key in CoreBeliefKeyType]?: string;
};
export type IntermediateBeliefType = {
  [key in IntermediateBeliefKeyType]?: string;
};
export type CopingStrategyType = {
  [key in CopingStrategyKeyType]?: string;
};

export type AutomaticThoughtBeliefType = {
  taskKey: string;
  intermediateBelief: string;
  copingStrategy: string;
};
export type AutomaticThoughtType = {
  [key in AutomaticThoughtKeyType]: string;
} & {
  impactScore?: number;
  impactScoreChange?: number;
  impactScoreHistoryList?: ImpactScoreHistoryListType[];
  thoughtRecordKey?: string;
  thoughtTrapList?: string[];
  thoughtList?: IndividualThoughtType[];
  isConfirmAvailable?: boolean;
  belief?: AutomaticThoughtBeliefType;
};

export interface ValueBehaviorType {
  taskKey: string;
  valueBehavior: string;
}

export type AutomaticThoughtForValueType = {
  [key in AutomaticThoughtForValueKeyType]: string;
} & {
  valueTaskKeyList?: string[];
  valueBehaviorList?: ValueBehaviorType[];
};

export type CoreBeliefNoteType = {
  [key in CoreBeliefKeyType]: NoteType;
} & {
  [key in CoreBeliefReferenceListType]?: ReferenceLinkType[];
};
export type IntermediateBeliefNoteType = {
  [key in IntermediateBeliefKeyType]: NoteType;
} & {
  [key in IntermediateBeliefReferenceListType]?: ReferenceLinkType[];
};
export type CopingStrategyNoteType = {
  [key in CopingStrategyKeyType]?: NoteType;
};

export type AutomaticThoughtNoteType = {
  [key in AutomaticThoughtKeyType]: NoteType;
} & {
  thoughtRecordKey?: string;
  thoughtTrapList?: NoteType[];
  thoughtList?: IndividualThoughtNoteType[];
  isConfirmAvailable?: boolean;
};
export type AutomaticThoughtForValueNoteType = {
  [key in AutomaticThoughtForValueKeyType]: NoteType;
} & {
  thoughtRecordKey?: string;
  isConfirmAvailable?: boolean;
};

export interface NoteType {
  value?: string;
  isHumanCheckRequired: boolean;
  isSaved?: boolean;
}

export interface ReferenceLinkType {
  referenceId: number;
  reference: string;
  thoughtRecordKey: string;
}

export type ConceptKeyType =
  | ConceptKeyType_concernAndGoal
  | ConceptKeyType_simple
  | ConceptKeyType_nested;

export type ConceptFieldKey = {
  [key in ConceptFieldKeyType]?: string;
};

export type ConceptType = {
  [key in ConceptKeyType_simple]?: string;
} & {
  [key in ConceptKeyType_coreBelief]?: CoreBeliefType;
} & {
  [key in ConceptKeyType_intermediateBelief]?: IntermediateBeliefType;
} & {
  [key in ConceptKeyType_copingStrategy]?: CopingStrategyType;
} & {
  [key in ConceptKeyType_automaticThought]?: AutomaticThoughtType;
} & {
  [key in ConceptKeyType_automaticThoughtForValue]?: AutomaticThoughtForValueType;
} & {
  [key in ConceptKeyType_concernAndGoal]?: string;
};

export type ConceptNoteType = { isOldVersion?: boolean } & {
  [key in ConceptKeyType_simple]?: NoteType;
} & {
  [key in CoreExperienceReferenceListType]?: ReferenceLinkType[];
} & {
  [key in ConceptKeyType_coreBelief]?: CoreBeliefNoteType;
} & {
  [key in ConceptKeyType_intermediateBelief]?: IntermediateBeliefNoteType;
} & {
  [key in ConceptKeyType_copingStrategy]?: CopingStrategyNoteType;
} & {
  [key in ConceptKeyType_automaticThought]?: AutomaticThoughtNoteType;
} & {
  [key in ConceptKeyType_automaticThoughtForValue]?: AutomaticThoughtForValueNoteType;
} & { [key in ConceptItemStatusKey]?: ConceptItemStatus } & {
  [key in ConceptKeyType_concernAndGoal]?: string;
};

export interface IntermediateBeliefs {
  rules?: string;
  attitudes?: string;
  assumptions?: string;
}

export interface CoreBeliefs {
  self?: string;
  others?: string;
  world?: string;
}

export interface Beliefs {
  coreExperience?: string;
  coreExperienceStatus?: ConceptItemStatus;
  coreBeliefs?: CoreBeliefs;
  coreBeliefsStatus?: ConceptItemStatus;
  intermediateBeliefs?: IntermediateBeliefs;
  intermediateBeliefsStatus?: ConceptItemStatus;
}

export interface ConcernAndGoal {
  concern?: string;
  goal?: string;
}

export interface AutomaticThought {
  automaticThoughtId: string;
  thoughtRecordKey: string;
  automaticThoughtStatus: ConceptItemStatus;
  sequence: number;
  situation?: string;
  thoughtList?: IndividualThoughtType[];
  emotion?: string;
  physicalResponse?: string;
  behavior?: string;

  isForValue: boolean;
  // 가치 영역
  thoughtPositive?: string;
  valueDomain?: string;
  value?: string;

  taskProgressStatus?: AutomaticThoughtTaskProgressStatus;
  isConfirmAvailable: boolean;
}

export interface AutomaticThoughtList {
  automaticThoughtList: AutomaticThought[];
}

export interface MemoType {
  memo: string;
}

export type ReferenceKeyType =
  | "coreExperienceReferenceList"
  | "coreBeliefReferenceList"
  | "intermediateBeliefReferenceList";
export type ImpactScoreKeyType =
  | "coreBeliefImpactScore"
  | "intermediateBeliefImpactScore";

export type ReferenceListType = {
  [key in ReferenceKeyType]?: string[];
};

export type ImpactScoreType = {
  [key in ImpactScoreKeyType]?: number;
};

export const conceptApi = {
  detail: (pid: number, tk?: string) =>
    axiosInstance.get<CustomResponseFormat<ConceptType>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_DETAIL_ENDPOINT}`,
      { params: { pid: pid, tk: tk } }
    ),
  confirm: (pid: number, conceptNoteKey: string) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_CONFIRM_ENDPOINT}`,
      { [conceptNoteKey]: true },
      { params: { pid: pid } }
    ),

  noteDetail: (pid: number, tk?: string) =>
    axiosInstance.get<CustomResponseFormat<ConceptNoteType>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_DETAIL_ENDPOINT}`,
      { params: { pid: pid, tk: tk } }
    ),

  noteConcernAndGoalDetail: (pid: number) =>
    axiosInstance.get<CustomResponseFormat<ConcernAndGoal>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_CONCERN_AND_GOAL_DETAIL_ENDPOINT}`,
      { params: { pid: pid } }
    ),

  noteBeliefsDetail: (pid: number) =>
    axiosInstance.get<CustomResponseFormat<Beliefs>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_BELIEFS_DETAIL_ENDPOINT}`,
      { params: { pid: pid } }
    ),

  noteAutomaticThoughtDetail: (pid: number, trk: string) =>
    axiosInstance.get<CustomResponseFormat<AutomaticThought | undefined>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_AUTOMATIC_THOUGHT_DETAIL_ENDPOINT}`,
      { params: { pid: pid, trk: trk } }
    ),

  noteAutomaticThoughtList: (pid: number) =>
    axiosInstance.get<CustomResponseFormat<AutomaticThought[]>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_AUTOMATIC_THOUGHT_LIST_ENDPOINT}`,
      { params: { pid: pid } }
    ),

  noteUpdate: (pid: number, body: ConceptType) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_UPDATE_ENDPOINT}`,
      body,
      { params: { pid: pid } }
    ),

  memoLoad: (pid: number) =>
    axiosInstance.get<CustomResponseFormat<MemoType>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_MEMOLOAD_ENDPOINT}`,
      { params: { pid: pid } }
    ),
  memoSave: (pid: number, memo: string) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_MEMOSAVE_ENDPOINT}`,
      { memo: memo },
      { params: { pid: pid } }
    ),

  addAutomaticThought: (pid: number, thoughtRecordKey: string) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_AUTOMATIC_THOUGHT_ADD_ENDPOINT}`,
      { thoughtRecordKey: thoughtRecordKey },
      { params: { pid: pid } }
    ),

  updateAutomaticThought: (
    pid: number,
    automaticThoughtId: string,
    body: AutomaticThoughtFieldMap,
    isForValue: boolean = false
  ) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_AUTOMATIC_THOUGHT_UPDATE_ENDPOINT}`,
      {
        automaticThoughtId: automaticThoughtId,
        isForValue: isForValue,
        ...body,
      },
      { params: { pid: pid } }
    ),

  deleteAutomaticThought: (
    pid: number,
    automaticThoughtId: string,
    isForValue: boolean = false
  ) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_AUTOMATIC_THOUGHT_DELETE_ENDPOINT}`,
      { automaticThoughtId: automaticThoughtId, isForValue: isForValue },
      { params: { pid: pid } }
    ),

  resetAutomaticThought: (
    pid: number,
    automaticThoughtId: string,
    isForValue: boolean = false
  ) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_AUTOMATIC_THOUGHT_RESET_ENDPOINT}`,
      { automaticThoughtId: automaticThoughtId, isForValue: isForValue },
      { params: { pid: pid } }
    ),

  confirmConceptNoteAutomaticThought: (
    pid: number,
    automaticThoughtId: string,
    isForValue: boolean = false
  ) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_AUTOMATIC_THOUGHT_CONFIRM}`,
      { automaticThoughtId: automaticThoughtId, isForValue: isForValue },
      { params: { pid: pid } }
    ),

  confirmConceptNote: (pid: number, conceptNoteKey: string) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_CONFIRM_ENDPOINT}`,
      { [conceptNoteKey]: true },
      { params: { pid: pid } }
    ),

  getReferenceDetail: (pid: number) =>
    axiosInstance.get<CustomResponseFormat<ReferenceListType>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_REFERENCE_DETAIL_ENDPOINT}`,
      { params: { pid: pid } }
    ),

  getReferenceList: (pid: number, conceptFieldKey: ConceptFieldKeyType) =>
    axiosInstance.get<CustomResponseFormat<ReferenceLinkType[]>>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_REFERENCE_LIST_ENDPOINT}`,
      { params: { pid: pid, concept_field_key: conceptFieldKey } }
    ),

  addReferenceLegacy: (pid: number, conceptType: string, reference: string) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_REFERENCE_ADD_ENDPOINT}`,
      { conceptType: conceptType, reference: reference },
      { params: { pid: pid } }
    ),

  addReference: (
    pid: number,
    conceptFieldKey: ConceptFieldKeyType,
    reference: string
  ) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_NOTE_REFERENCE_ADD_ENDPOINT}`,
      { conceptFieldKey: conceptFieldKey, reference: reference },
      { params: { pid: pid } }
    ),

  submitImpactScore: (body: ImpactScoreType) =>
    axiosInstance.post<void>(
      `${CONCEPT_DOMAIN}/${CONCEPT_IMPACTSCORE_SUBMIT_ENDPOINT}`,
      body
    ),
};
